/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddExcuseCommand } from '../../models/add-excuse-command';
import { AddExcuseCommandResult } from '../../models/add-excuse-command-result';

export interface ApiPlanAddExcusePost$Plain$Params {
  
    /**
     * Add Excuse
     */
    body?: AddExcuseCommand
}

export function apiPlanAddExcusePost$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanAddExcusePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddExcuseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanAddExcusePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddExcuseCommandResult>;
    })
  );
}

apiPlanAddExcusePost$Plain.PATH = '/api/Plan/AddExcuse';
